import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { useMemo } from 'react';
import { GDD_COLOUR, GDD_THRESHOLD, RAINFALL_COLOUR } from '../../utils';

const G3ForecastingChart = ({ g3Model }) => {
  const options = useMemo(() => {
    const dates = g3Model.SDATA || [];
    const gddAccumulation = g3Model.GDD_ACCUMULATION || [];
    const rainfall = g3Model.RNDATA || [];

    const thresholdIndex = gddAccumulation.findIndex(
      (v) => Number(v) >= GDD_THRESHOLD
    );
    const cutoff = thresholdIndex === -1 ? dates.length : thresholdIndex + 1;

    const gddData = dates
      .slice(0, cutoff)
      .map((seconds, i) => [seconds * 1000, Number(gddAccumulation[i])]);
    const rainfallData = dates
      .slice(0, cutoff)
      .map((seconds, i) => [seconds * 1000, Number(rainfall[i])]);

    return {
      chart: {
        type: 'line'
      },
      credits: {
        enabled: false
      },
      time: {
        timezone: 'Pacific/Auckland'
      },
      title: {
        text: 'G3 Forecasting'
      },
      xAxis: {
        type: 'datetime',
        tickInterval: 2 * 7 * 24 * 3600 * 1000,
        gridLineWidth: 1,
        labels: {
          format: '{value:%e-%b}'
        }
      },
      yAxis: [
        {
          title: {
            text: "GDD's"
          },
          plotLines: [
            {
              value: GDD_THRESHOLD,
              color: GDD_COLOUR,
              width: 2,
              dashStyle: 'Dash',
              zIndex: 3,
              label: {
                text: `${GDD_THRESHOLD} GDD`
              }
            }
          ]
        },
        {
          title: {
            text: 'Rainfall (mm)'
          },
          opposite: true
        }
      ],
      legend: {
        enabled: true
      },
      plotOptions: {
        line: {
          marker: {
            enabled: false
          }
        }
      },
      tooltip: {
        valueDecimals: 2
      },
      series: [
        {
          name: "Accum GDD's from G2 (base 3.7)",
          data: gddData,
          color: GDD_COLOUR,
          yAxis: 0
        },
        {
          name: 'Rainfall (mm)',
          data: rainfallData,
          color: RAINFALL_COLOUR,
          yAxis: 1
        }
      ]
    };
  }, [g3Model]);

  return <HighchartsReact highcharts={Highcharts} options={options} />;
};

export default G3ForecastingChart;

